<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label for="Name">
                          <span class="required">*</span> Nome:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="users.name"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="Name">
                          <span class="required">*</span> CPF:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="CPF"
                          class="form-control"
                          v-model="users.cpf_cnpj"
                          placeholder=""
                          v-mask="'999.999.999-99'"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Email">
                          <span class="required">*</span> Email:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="Email"
                          placeholder=""
                          type="text"
                          v-model="users.email"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Login">
                          <span class="required">*</span> Login:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="Login"
                          placeholder=""
                          type="text"
                          v-model="users.login"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="Cellphone">Celular:</label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="Cellphone"
                          type="text"
                          v-mask="'(99) 99999-9999'"
                          v-model="users.cellphone"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label>Tipo de Profissional:</label>
                        <v-select
                          :options="cbos"
                          :reduce="(cbos) => cbos.id"
                          :label="'nome'"
                          v-model="users.cbo_id"
                          class="vselect"
                        ></v-select>
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputUser">
                          <span class="required">*</span> Nível de acesso:
                        </label>
                        <v-select
                          :options="niveis"
                          :reduce="(niveis) => niveis.id"
                          :label="'nome'"
                          v-model="users.access_nivel"
                          class="vselect"
                        ></v-select>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label>Setor:</label>
                        <v-select
                          :options="setores"
                          :reduce="(setores) => setores.id"
                          :label="'nome'"
                          v-model="users.setores"
                          class="vselect"
                          multiple
                        ></v-select>
                      </div>
                    </div>
                    <div class="row" v-if="$route.params.id">
                      <div class="col-md-12 mb-2">
                        <button
                          type="button"
                          class="btn btn-add"
                          @click="toggleFormSenha"
                        >
                          <i class="fas fa-key"></i> Alterar Senha
                        </button>
                      </div>
                    </div>
                    <div class="form-row" v-if="change_password">
                      <div class="form-group col-md-6">
                        <label for="password">
                          <span class="required">*</span> Senha:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="password"
                          id="password"
                          class="form-control"
                          v-model="users.password"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="confirmPassword">
                          <span class="required">*</span> Confirme a senha:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="confirmPassword"
                          placeholder=""
                          type="password"
                          v-model="users.password_confirmation"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="userPic"> Foto do Perfil </label>
                      <div class="user-img">
                        <img
                          v-if="previewImage"
                          :src="previewImage"
                          class="photo"
                        />
                        <img v-else class="photo" />
                      </div>
                      <input
                        type="file"
                        class=""
                        id="userPic"
                        accept="image/*"
                        name="userPic"
                        @change="uploadImage"
                        placeholder
                      />
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <router-link to="/users" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      companies: [],
      departments: [],
      change_password: false,
      cbos: [],
      users: {
        setores: [],
        name: "",
        email: "",
        cellphone: "",
        telphone: "",
        photo: "",
        access_nivel: "",
        password: "",
        password_confirmation: "",
        cbo_id: "",
        cpf_cnpj: "",
      },
      companies: {},
      departments: {},
      errors: undefined,
      previewImage: null,
      niveis: [
        {
          id: 1,
          nome: "Chamador",
        },
        {
          id: 2,
          nome: "Chamador + Mover senhas",
        },
        {
          id: 3,
          nome: "Chamador + Relatórios",
        },
        {
          id: 4,
          nome: "Chamador + Relatórios + Fechar dia",
        },
        {
          id: 5,
          nome: "Gerenciar unidade",
        },
        {
          id: 6,
          nome: "Usuário da segurança",
        },
        {
          id: 7,
          nome: "Administrador do sistema",
        },
      ],
    };
  },
  computed: {},
  methods: {
    toggleFormSenha() {
      const self = this;
      if (self.change_password) {
        self.change_password = false;
      } else {
        self.change_password = true;
      }
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();
      let photo = document.getElementById("userPic");
      let setor_obj = [];
      let i = 0;

      self.users.setores.forEach((setor) => {
        if (setor.id) {
          setor_obj[i] = setor.id;
        } else {
          setor_obj[i] = setor;
        }
        i++;
      });

      fd.append("name", self.users.name);
      fd.append("email", self.users.email);
      fd.append("login", self.users.login);
      fd.append("cbo_id", self.users.cbo_id);
      fd.append("cpf_cnpj", self.users.cpf_cnpj);
      fd.append("cellphone", self.users.cellphone);
      fd.append("access_nivel", self.users.access_nivel);
      fd.append("password", self.users.password);
      fd.append("password_confirmation", self.users.password_confirmation);
      fd.append("calendar_color", self.users.calendar_color);
      fd.append("accept_terms", 0);

      fd.append("setores", setor_obj);

      fd.append("_method", "POST");

      fd.append("photo", photo.files[0] ? photo.files[0] : "");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      if (self.users.setores.length) {
        self.$loading(true);

        let fd = self.makeFormData();

        if (self.users.id) {
          api += "/" + self.users.id;
        }

        axios
          .post(api, fd)
          .then((response) => {
            self.$message(
              "Sucesso",
              `Informações guardadas com sucesso`,
              "success"
            );

            self.$loading(false);

            this.$router.push("/users");
          })
          .catch((error) => {
            self.$loading(false);
            self.$message(null, error.response.data, "error");
          });
      } else {
        self.$message(null, "Selecione ao menos um setor", "error");
      }
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.users.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.users.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.users.street = self.endereco.logradouro;
            self.users.neighborhood = self.endereco.bairro;
            self.users.state = self.endereco.uf;
            self.users.city = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getUsers: function (id) {
      const self = this;
      const api =
        self.$store.state.api + `users/${id}?with[]=setores&paginated=false`;

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
          self.users.password = "";
          self.change_password = false;

          self.niveis = [
            {
              id: 1,
              nome: "Chamador",
            },
            {
              id: 2,
              nome: "Chamador + Mover senhas",
            },
            {
              id: 3,
              nome: "Chamador + Relatórios",
            },
            {
              id: 4,
              nome: "Chamador + Relatórios + Fechar dia",
            },
            {
              id: 5,
              nome: "Gerenciar unidade",
            },
            {
              id: 6,
              nome: "Usuário da segurança",
            },
            {
              id: 7,
              nome: "Administrador do sistema",
            },
          ];

          self.setLoader(35);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCbos: function () {
      const self = this;
      const api = self.$store.state.api + "cbos?paginated=false&ativo=1";

      axios
        .get(api)
        .then((response) => {
          self.cbos = response.data.data;
          self.setLoader(20);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSetores: function () {
      const self = this;
      const api = self.$store.state.api + "setores?paginated=false&ativo=1";

      axios
        .get(api)
        .then((response) => {
          self.setores = response.data.data;
          self.setLoader(20);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
      };
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(25);
    self.getCbos();
    self.getSetores();

    if (id) {
      self.change_password = false;
      self.getUsers(id);
    } else {
      self.change_password = true;
      self.setLoader(35);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>